exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gap-sm[data-v-49bc2b16] {\n  gap: 8px;\n}\n.table th[data-v-49bc2b16] {\n  font-weight: 500;\n  font-size: 13px;\n  color: #6B7280;\n}\n.table td[data-v-49bc2b16] {\n  font-size: 13px;\n  vertical-align: middle;\n}\n@media (max-width: 576px) {\n.btn-download-modal[data-v-49bc2b16] {\n    width: 100%;\n    justify-content: center;\n}\n.modal-statement-footer[data-v-49bc2b16] {\n    flex-direction: column-reverse;\n}\n.modal-statement-footer button[data-v-49bc2b16] {\n    width: 100%;\n    justify-content: center;\n}\n}", ""]);

// exports
